import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import { Provider } from 'react-redux'
import App from './App'
import * as serviceWorker from './serviceWorker'
import 'bootstrap/dist/css/bootstrap.min.css'
import store from './init-redux'
import { ThemeProvider } from 'styled-components'
import theme from './styles/theme'


ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <App />
      </Provider>
    </ ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)

serviceWorker.unregister()
